module.exports = __webpack_public_path__ + "static/FoodMaven-dfd62df8cf9e76654ebee2e4cf22b980.jpg";